import Request from 'gd-request';

import PropTypes from 'prop-types';

import React from 'react';

import ButtonDeprecated from 'core/gd-components/buttons/gd-button/gd-button.tsx';

class ModalCloseNotEmptyProject extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            projectId: PropTypes.string.isRequired, // project we want to close
            newSystemStatus: PropTypes.number,
            newStatusId: PropTypes.string
        })
    };

    state = {
        isBusy: false
    };

    onConfirm = () => {
        const { newSystemStatus, newStatusId, projectId } = this.props.params;

        this.setState({
            isBusy: true
        }, ()=>{
            const res = new Request(this,'put','project/'+projectId+"/status",{
                systemStatus: newSystemStatus,
                status: newStatusId,
                forceClose: true
            });

            res.done((data)=>{
                this.props.params.onSubmit();
                gd.modal.hide();
            });
        });
    };

    onCancel = () => {
        this.props.params.onCancel();
        gd.modal.hide();
    };

    doNothing = () => {
        //do nothing
    };

    render() {
        const { isBusy } = this.state;
        const project = gd.session.projects.get(this.props.params.projectId);

        const confirmType = isBusy ? "busy" : "primary";

        return (
            <div>
                <div className="l1">Project <strong>{project.name}</strong> contains open tasks and/or folders.</div>
                <div className="l2">Click confirm if you still want to archive it (all items will be automatically closed/archived).</div>
                <ButtonDeprecated label="Confirm" type={confirmType} onClick={isBusy ? this.doNothing : this.onConfirm} className="btn-confirm"/>
                <ButtonDeprecated label="Cancel" onClick={isBusy ? this.doNothing : this.onCancel} />
            </div>
        )
    }
}

module.exports = ModalCloseNotEmptyProject;